// Stop body scroll on Modal opening
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

(() => {
  const selectors = ['.js-menu-icon'];
  const nav = document.getElementById('navbar');
  const menuIcon = document.querySelector('.js-menu-icon');

  const modalCloseTriggers = document.querySelectorAll('.js-modal-close-trigger');

  function hideActiveModal() {
    const activeModal = document.querySelector('.js-modal.active');

    menuIcon.classList.remove('fixed');
    enableBodyScroll(activeModal);
    activeModal.classList.remove('active');
  }

  function modalTriggerClicked(e, trigger) {
    e.preventDefault();

    if (trigger.classList.contains('js-menu-icon') && trigger.classList.contains('active')) {
      hideActiveModal();
      trigger.classList.remove('active');
    } else {
      document.querySelector('.js-menu-icon[data-modal="menu"]').classList.remove('active');
      const modalSelector = trigger.dataset.modal
        ? trigger.dataset.modal
        : trigger.getAttribute('href');
      const selectedModal = document.getElementById(modalSelector);

      document.querySelectorAll('.js-modal').forEach(modal => {
        if (modal !== selectedModal) {
          modal.classList.remove('active');
        }
      });

      menuIcon.classList.add('active');

      if (selectedModal.classList.contains('active')) {
        hideActiveModal();
      } else {
        selectedModal.classList.add('active');
        disableBodyScroll(selectedModal);
        menuIcon.classList.add('fixed');
        menuIcon.style.top = `${22}px`;
        nav.classList.remove('dark-nav');
        nav.classList.add('light-nav');
        nav.classList.remove(nav.dataset.background);
        nav.style.top = `${0}px`;
      }
    }

    let count = 0;
    document.querySelectorAll('.js-modal').forEach(modal => {
      if (modal.classList.contains('active')) {
        count += 1;
      }
    });

    if (count === 0) {
      clearAllBodyScrollLocks();
      menuIcon.classList.remove('active');
      nav.classList.remove('dark-nav');
      nav.classList.remove('light-nav');
      nav.classList.add(nav.dataset.style);

      // Not at top of the document
      if (window.pageYOffset > 0) {
        nav.classList.add(nav.dataset.background);
      }
    }
  }

  function init() {
    selectors.forEach(selector => {
      const triggers = document.querySelectorAll(selector);

      triggers.forEach(trigger => {
        trigger.addEventListener('click', e => {
          modalTriggerClicked(e, trigger);
        });
      });
    });

    modalCloseTriggers.forEach(closeTrigger => {
      closeTrigger.addEventListener('click', () => {
        hideActiveModal();
        menuIcon.classList.remove('active');
      });
    });
  }

  init();
})();
